import jishikaijiang from '../../Jishikaijiang/columns/choose5';

export default {
  list: Vue => {
    return jishikaijiang().list(Vue);
  }
};


// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/choose5.js